
import { InitialAssemblyState, InitialShadeState } from "../../../Store/entities/assemblies";
import { AssemblyStore, CurrentPSOutdoorShadeOptionsFunc, PSOutdoorColor, PSOutdoorControlSide, PSOutdoorHeaderMountType, PSOutdoorHeaderTypeSku, PortalShadeOptionItem, PSOutdoorShadeOptionsDict, PSOutdoorShadeOptionsFunc, PSOutdoorSideGuideMountTypes, PSOutdoorSideGuides, CardinalDirectionType } from "../../../Store/entities/assemblies/types";
import { UseAssembly } from "./hooks";

import TopBoxHeaderMount from "../../../assets/img/outdoor_diagrams/header_mount/box-top-fix.jpg";
import SideBoxHeaderMount from "../../../assets/img/outdoor_diagrams/header_mount/box-side-fix.jpg";
import FaceBoxHeaderMount from "../../../assets/img/outdoor_diagrams/header_mount/box-face-fix.jpg";
import TopOpenRollHeaderMount from "../../../assets/img/outdoor_diagrams/header_mount/open-roll-top-fix.jpg";
import SideOpenRollHeaderMount from "../../../assets/img/outdoor_diagrams/header_mount/open-roll-side-fix.jpg";
import FaceOpenRollHeaderMount from "../../../assets/img/outdoor_diagrams/header_mount/open-roll-face-fix.jpg";
import { usePSOutdoorFabrics } from "../hooks";
import { useUser } from "../../user/hooks";
import { useQuoteById } from "../quotes/hooks";



const useCurrentPSOutdoorShadeOptions: CurrentPSOutdoorShadeOptionsFunc = (quoteId) => (sequenceId) => {


    const assembly = UseAssembly(quoteId, sequenceId) ?? InitialAssemblyState();

    const setAssembly = (assembly: AssemblyStore) => {
        console.log(assembly);
    }

    const fabrics = usePSOutdoorFabrics();
    const userData = useUser();
    const quote = useQuoteById(quoteId);

    return useNewPSOutdoorShadeOptions(assembly, setAssembly, {fabrics: fabrics, user: userData, quote});
}


// Generic Factory Function to make one list of options to rule them all. 
const useNewPSOutdoorShadeOptions: PSOutdoorShadeOptionsFunc = (assembly, setAssemblyInit, externalData, allOptionOverride = false) => {

    const firstShade = assembly.shades[0] ?? InitialShadeState(); // Should be the only shade.

    const setAssembly = (assemblyNew: Partial<AssemblyStore>) => {
        setAssemblyInit({
            ...assembly,
            ...assemblyNew
        });
    }

    const fabricList = externalData?.fabrics ?? [];

    const fabricOptions: PortalShadeOptionItem<string>[] = fabricList.map((fabric) => {
        return {
            label: fabric.name,
            value: fabric.name,
            title: fabric.name
        }
    });

    // Header Specific Options 
    const isBoxHeader = assembly.header_type.includes("Box");
    const isOpenHeader = assembly.header_type.includes("Open Roll");
    const isBox120Header = assembly.header_type.includes("Box 120");
    const isBig = assembly.header_type.includes("Box 190") || assembly.header_type.includes("Open Roll Extreme");

    let mountTypeOptions: PortalShadeOptionItem<PSOutdoorHeaderMountType>[] = [
        {
            label: "Top",
            value: "Top",
            title: "Top Fix"
        },
        {
            label: "Face",
            value: "Face",
            title: "Face Fix"
        },
        {
            label: "Side",
            value: "Side",
            title: "Side Fix"
        }
    ];
    if (isBox120Header && !allOptionOverride) {
        // Top and Face only
        // mountTypeOptions = mountTypeOptions.filter((option) => option.value === "Top" || option.value === "Face");
        
    } else if (isBoxHeader && !allOptionOverride) {
        // All
    } else if (isOpenHeader && !allOptionOverride) {
        // All
    }

    // Side Mount Specific Options

    let sideMountTypeOptions: PortalShadeOptionItem<PSOutdoorSideGuideMountTypes>[] = [
        {
            label: "Floor",
            value: "Floor",
            title: "Floor Fix"
        },
        {
            label: "Side",
            value: "Side",
            title: "Side Fix"
        },
        {
            label: "Face",
            value: "Face Fixed",
            title: "Face Fixed"
        }
    ];

    const isWire = assembly.side_channels === 'Wire';
    const isZip = assembly.side_channels === 'Zip';

    if (isWire) {
        // Floor, Side, Face (All)
        
    } else if (isZip) {
        // Side or Face
        sideMountTypeOptions = sideMountTypeOptions.filter((option) => option.value === "Side" || option.value === "Face Fixed");
    }

    // Color options
    let colorOptions: PortalShadeOptionItem<PSOutdoorColor>[] = [
        {
            label: "Black",
            value: "Black",
            title: "Black"
        },
        {
            label: "Paper Bark",
            value: "Paper Bark",
            title: "Paper Bark"
        },
        {
            label: "Bronze",
            value: "Bronze",
            title: "Bronze"
        }
    ];

    // Black Bronze 'Paper White'

    if (isBig) {
        // 190 Box and Large Open Roll only get black.
        colorOptions = colorOptions.filter((option) => option.value === "Black");
      
    } else {
       // All
    }

    // Header Type Options 
    const headerTypeOptions: PortalShadeOptionItem<PSOutdoorHeaderTypeSku>[] = [
        { label: 'Open Roll', value: "Open Roll 120", title: "Open Roll 120" },
        { label: 'Large Open Roll', value: "Open Roll Extreme", title: "Open Roll Extreme" },
        { label: 'Box (120)', value: "Box 120", title: "Box 120" },
        { label: 'Large Box (190)', value: "Box 190", title: "Box 190" }
    ];

    // Control Side Options
    const controlSideOptions: PortalShadeOptionItem<PSOutdoorControlSide>[] = [
        {
            label: "Left",
            value: "Left",
            title: "Left"
        },
        {
            label: "Right",
            value: "Right",
            title: "Right"
        }
    ]

    // Side Guide Options
    let sideGuideOptions: PortalShadeOptionItem<PSOutdoorSideGuides>[] = [
        {
            label: "Zip Screen",
            value: "Zip",
            title: "Zip"
        },
        {
            label: (assembly.header_type.includes("Open Roll Extreme") || assembly.header_type.includes("Box 190"))
                ? "Wire Guide (4.0 mm)"
                : "Wire Guide (3.2 mm)",
            value: "Wire",
            title: "Wire"
        }
    ]

   
    if (assembly.header_type.includes("Open Roll")) {
        // Only Wire
        sideGuideOptions = sideGuideOptions.filter((option) => option.value === "Wire");

    } else if (assembly.header_type.includes("Box 190")) {
        // Only Zip
        sideGuideOptions = sideGuideOptions.filter((option) => option.value === "Zip" || option.value === "Wire");
    }

    const directionFacingOptions = [
        { label: "North", value: "North" as CardinalDirectionType, title: "North" },
        { label: "South", value: "South" as CardinalDirectionType, title: "South" },
        { label: "East", value: "East" as CardinalDirectionType, title: "East" },
        { label: "West", value: "West" as CardinalDirectionType, title: "West" },
        { label: "Northeast", value: "Northeast" as CardinalDirectionType, title: "Northeast" },
        { label: "Northwest", value: "Northwest" as CardinalDirectionType, title: "Northwest" },
        { label: "Southeast", value: "Southeast" as CardinalDirectionType, title: "Southeast" },
        { label: "Southwest", value: "Southwest" as CardinalDirectionType, title: "Southwest" },
        { label: "Unknown", value: "Unknown" as CardinalDirectionType, title: "Unknown" }
    ]


    let options: PSOutdoorShadeOptionsDict | null = null;

    options = {
        Width: {
            varName: "Width",
            label: "Width",
            error: [],
            info: [],
            minValue: 27,
            maxValue: 238,
            getValue: function (): number {
                return firstShade.width;
            },
            setValue: function (newVal: number): void {
                let newWidth = newVal;
                let minVal = options?.Width.minValue ?? 0;
                let maxVal = options?.Width.maxValue ?? 0;
                if (newWidth < minVal) newWidth = minVal;
                if (newWidth > maxVal) newWidth = maxVal;

                setAssembly({
                    shades: [
                        {
                            ...firstShade,
                            width: newWidth
                        }
                    ]
                })
            },
            getSelectedOption: () => {
                return {
                    label: firstShade.width.toString(),
                    value: firstShade.width,
                    title: firstShade.width.toString()
                }
            },
            clearValue: () => {
                setAssembly({
                    shades: [
                        {
                            ...firstShade,
                            width: 0
                        }
                    ]
                })
            },
            
        },
        Height: {
            varName: "height",
            label: "Height",
            error: [],
            info: [],
            minValue: 12,
            maxValue: 240,
            getValue: function (): number {


                return firstShade.height;
            },
            setValue: function (newVal: number): void {
                let newHeight = newVal;
                let minVal = options?.Height.minValue ?? 0;
                let maxVal = options?.Height.maxValue ?? 0;
                if (newHeight < minVal) newHeight = minVal;
                if (newHeight > maxVal) newHeight = maxVal;

                setAssembly({
                    shades: [
                        {
                            ...firstShade,
                            height: newHeight
                        }
                    ]
                })
            },
            getSelectedOption: () => {
                return {
                    label: firstShade.height.toString(),
                    value: firstShade.height,
                    title: firstShade.height.toString()
                }
            },
            clearValue: () => {
                setAssembly({
                    shades: [
                        {
                            ...firstShade,
                            height: 0
                        }
                    ]
                })
            }
        },
        HeaderMountType: {
            varName: "header_mount_type",
            label: "Header Mount",
            error: [],
            info: [],
            getValue: function (): PSOutdoorHeaderMountType {
                return assembly.mount_type as PSOutdoorHeaderMountType;
            },
            setValue: (newVal) => {
                setAssembly({
                    mount_type: newVal
                })
            },
            options: mountTypeOptions,
            getSelectedOption: () => {
                return mountTypeOptions.find((option) => option.value === assembly.mount_type) as PortalShadeOptionItem<PSOutdoorHeaderMountType>;
            },
            clearValue: () => {
                setAssembly({
                    mount_type: ""
                })
            },
            valuePopup: assembly.mount_type === "Top" && isBoxHeader ? TopBoxHeaderMount :
                        assembly.mount_type === "Face" && isBoxHeader ? FaceBoxHeaderMount :
                        assembly.mount_type === "Side" && isBoxHeader ? SideBoxHeaderMount :
                        assembly.mount_type === "Top" && !isBoxHeader ? TopOpenRollHeaderMount :
                        assembly.mount_type === "Face" && !isBoxHeader ? FaceOpenRollHeaderMount :
                        assembly.mount_type === "Side" && !isBoxHeader ? SideOpenRollHeaderMount : ""

        },
        HeaderType: {
            varName: "header_type",
            label: "Header",
            error: [],
            info: [],
            getValue: function (): PSOutdoorHeaderTypeSku {
                return assembly.header_type as PSOutdoorHeaderTypeSku;
            },
            setValue: function (newVal): void {
                setAssembly({
                    header_type: newVal
                })
            },
            options: headerTypeOptions,
            getSelectedOption: () => {
                return headerTypeOptions.find((option) => option.value === assembly.header_type) as PortalShadeOptionItem<PSOutdoorHeaderTypeSku>;
            },
            clearValue: () => {
                setAssembly({
                    header_type: ""
                })
            }
        },
        Color: {
            varName: "hardware_color",
            label: "Color",
            error: [],
            info: [],
            getValue: function (): PSOutdoorColor {
                return assembly.hardware_color as PSOutdoorColor;
            },
            setValue: function (newVal: PSOutdoorColor): void {
                setAssembly({
                    hardware_color: newVal
                })
            },
            options: colorOptions,
            getSelectedOption: () => {
                return colorOptions.find((option) => option.value === assembly.hardware_color) as PortalShadeOptionItem<PSOutdoorColor>;
            },
            clearValue: () => {
                setAssembly({
                    hardware_color: ""
                })
            }
        },
        Fabric: {
            varName: "fabric_name",
            label: "Fabric",
            error: [],
            info: [],
            getValue: function (): string {
                return firstShade.fabric_name as string;
            },
            setValue: function (newVal: string): void {
                setAssembly({
                    shades: [
                        {
                            ...firstShade,
                            fabric_name: newVal
                        }
                    ]
                })
            },

            options: fabricOptions,
            getSelectedOption: () => {
                return fabricOptions.find((option) => option.value === firstShade.fabric_name) as PortalShadeOptionItem<string>;
            },
            clearValue: () => {
                setAssembly({
                    shades: [
                        {
                            ...firstShade,
                            fabric_name: ""
                        }
                    ]
                })
            }
        },
        ControlSide: {
            varName: "control_side",
            label: "Control Side",
            error: [],
            info: [],
            getValue: function (): PSOutdoorControlSide {
                return assembly.control_side as PSOutdoorControlSide;
            },
            setValue: function (newVal: PSOutdoorControlSide): void {
                setAssembly({
                    control_side: newVal
                })
            },
            options: controlSideOptions,
            getSelectedOption: () => {
                return controlSideOptions.find((option) => option.value === assembly.control_side) as PortalShadeOptionItem<PSOutdoorControlSide>;
            },
            clearValue: () => {
                setAssembly({
                    control_side: ""
                })
            }

        },
        SideGuides: {
            varName: "side_channels",
            label: "Side Guides",
            error: [],
            info: [],
            getValue: function (): PSOutdoorSideGuides {
                return assembly.side_channels as PSOutdoorSideGuides;
            },
            setValue: function (newVal: PSOutdoorSideGuides): void {
                setAssembly({
                    side_channels: newVal
                })
            },
            options: sideGuideOptions,
            getSelectedOption: () => {
                return sideGuideOptions.find((option) => option.value === assembly.side_channels) as PortalShadeOptionItem<PSOutdoorSideGuides>;
            },
            clearValue: () => {
                setAssembly({
                    side_channels: ""
                })
            }
        },
        SideGuideMountTypes: {
            varName: "side_channel_mount_type",
            label: "Side Guide Mount Types",
            error: [],
            info: [],
            getValue: function (): PSOutdoorSideGuideMountTypes {
                return assembly.side_channels_mount_type as PSOutdoorSideGuideMountTypes;
            },
            setValue: function (newVal: PSOutdoorSideGuideMountTypes): void {
                setAssembly({
                    side_channels_mount_type: newVal
                })
            },
            options: sideMountTypeOptions,
            getSelectedOption: () => {
                return sideMountTypeOptions.find((option) => option.value === assembly.side_channels_mount_type) as PortalShadeOptionItem<PSOutdoorSideGuideMountTypes>;
            },
            clearValue: () => {
                setAssembly({
                    side_channels_mount_type: ""
                })
            }
        },
        RoomName: {
            varName: "room_name",
            label: "Room/Area Name",
            error: [],
            info: [],
            getValue: function (): string {
                return assembly.room_name as string;
            },
            setValue: function (newVal: string): void {
                setAssembly({
                    room_name: newVal
                })
            },
            getSelectedOption: () => {
                return {
                    label: assembly.room_name,
                    value: assembly.room_name,
                    title: assembly.room_name
                }
            },
            options: [],
            clearValue: () => {
                setAssembly({
                    room_name: ""
                })
            }
        },
        ShadeName: {
            varName: "shade_name",
            label: "Shade Name",
            error: [],
            info: [],
            getValue: function (): string {
                return assembly.shade_name as string;
            },
            setValue: function (newVal: string): void {
                setAssembly({
                    shade_name: newVal
                })
            },
            options: [],
            getSelectedOption: () => {
                return {
                    label: assembly.shade_name,
                    value: assembly.shade_name,
                    title: assembly.shade_name
                }
            },
            clearValue: () => {
                setAssembly({
                    shade_name: ""
                })
            }
        },
        DirectionFacing: {
            varName: "direction_facing",
            label: "Direction Facing",
            error: [],
            info: [],
            getValue: function (): string {
                return assembly.direction_facing as string;
            },
            setValue: function (newVal: string): void {
                setAssembly({
                    direction_facing: newVal
                })
            },
            options: directionFacingOptions,
            getSelectedOption: () => {
                return directionFacingOptions.find(direction => direction.value === assembly.direction_facing) ?? { label: "", value: "" as CardinalDirectionType, title: "" };
            },
            clearValue: () => {
                setAssembly({
                    direction_facing: ""
                })
            }
        },
        Floor: {
            varName: "fllor",
            label: "Floor",
            error: [],
            info: [],
            minValue: 0,
            maxValue: 100,
            getValue: function (): number {
                return assembly.floor as number;
            },
            setValue: function (newVal: number): void {
                setAssembly({
                    floor: newVal
                })
            },
            getSelectedOption: () => {
                return {
                    label: assembly.floor.toString(),
                    value: assembly.floor,
                    title: assembly.floor.toString()
                }
            },
            clearValue: () => {
                setAssembly({
                    floor: 0
                })
            }
        },
    };

    // Generic Option Validation

    Object.values(options).forEach((option) => {
        const optionVal = option.getValue();
        if (optionVal === undefined || optionVal === null || optionVal === "") {
            option.error.push("This field is required");
        }

        if (typeof optionVal === "number") {
            if (optionVal < (option?.minValue ?? 0) || optionVal > (option.maxValue ?? 0)) {
                option.error.push(`Value must be between ${option.minValue} and ${option.maxValue}`);
            }
        } else {
            if ((option.options?.length ?? 0) > 0 && !option.options?.find(option => option.value === optionVal)) {
                option.error.push("Invalid Option");
            }
        }


    });

    Object.values(options).forEach(option => {
        option.options?.forEach(opt => {
            opt.isActive = true;
        })
    });

    return options;
}

export {
    useCurrentPSOutdoorShadeOptions,
    useNewPSOutdoorShadeOptions
};

